import { connect } from 'react-redux';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterItem from "./FilterItem";

class FilterGroup extends Component {

    state = {
        toggle: true
    };

    toggle = () => {
        this.setState({ toggle: !this.state.toggle });
    };

    render() {
        const { toggle } = this.state;
        const { key } = this.props;

        const group = this.props.filterLists[this.props.filterId];

        if (typeof group.filter_values === 'undefined' || group.filter_values.length === 0) return null;

        return (
            <div className="filter-list-item" key={key}>
                <button className={['accordion-trigger', toggle && group.filter_values.length && 'open'].join(' ')} onClick={this.toggle}>
                    <span>{group.name}</span>
                    <i className="icon icon-arrow-down"></i>
                </button>
                <div className={['accordion-panel', toggle && group.filter_values.length && 'open'].join(' ')}>
                    <FilterItem filter_type={group.filter_type}
                        filter_values={group.filter_values}
                        filter_group_id={group.id} />
                </div>
            </div>
        );
    }
}

FilterGroup.propTypes = {
    filterLists:  PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => ({
    filterLists: state.filterLists || {},
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FilterGroup);

